import React from 'react';
import '../styles/AboutUs.css';
import subhrajitImg from '../assets/images/subhrajitimg.jpg';
import bijitImg from '../assets/images/bijitimg.jpg';

const AboutUs = () => {
  return (
    <div className='about-us'>
      <div className='overlay'></div>
      <div className='about-container'>
        <header className='about-header'>
          <h1>
            About <span className='accent'>MotoGuru AI</span>
          </h1>
          <p className='tagline'>Your intelligent motorcycle advisor powered by AI technology</p>
        </header>

        <div className='about-content'>
          <div className='about-section'>
            <div className='section-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm2.946 2.854a7.02 7.02 0 0 1 1.163 1.307c.148.192.272.344.398.552a6.85 6.85 0 0 1 .651 1.337l-2.559 1.535a3.977 3.977 0 0 0-.532-.906 4.093 4.093 0 0 0-2.053-1.478l.384-2.93c.902.112 1.757.47 2.548 1.583zm-5.387.89 .384 2.93a4.077 4.077 0 0 0-1.439 1.313c-.413.608-.667 1.326-.728 2.093l-2.876-.142a6.83 6.83 0 0 1 .27-1.561c.122-.336.296-.684.436-.9a7.104 7.104 0 0 1 .723-1.08A7.094 7.094 0 0 1 5.559 3.744zM6.09 11.904a3.94 3.94 0 0 0 2.252.753c.51.013 1.02-.082 1.5-.303.482-.22.918-.544 1.283-.958l2.3 1.904a6.817 6.817 0 0 1-2.068 1.438 6.83 6.83 0 0 1-2.343.533 7.465 7.465 0 0 1-1.976-.167 7.055 7.055 0 0 1-2.001-.872l1.053-2.328z' />
              </svg>
            </div>
            <div className='section-content'>
              <h2>Our Mission</h2>
              <p>
                At MotoGuru AI, we're passionate about helping riders find their perfect motorcycle match. Using advanced AI technology, we provide personalized motorcycle recommendations based on your experience level, riding style, budget, and specific preferences. Whether you're a beginner
                looking for your first bike or an experienced rider seeking an upgrade, our intelligent motorcycle advisor is here to guide you.
              </p>
            </div>
          </div>

          <div className='about-section'>
            <div className='section-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.25-11.25v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0zm0 4v4.75a.75.75 0 0 1-1.5 0v-4.75a.75.75 0 0 1 1.5 0z' />
              </svg>
            </div>
            <div className='section-content'>
              <h2>Why Choose MotoGuru AI?</h2>
              <p>
                Unlike general motorcycle search engines, MotoGuru AI offers tailored advice that considers your unique requirements. Our AI-powered motorcycle search analyzes thousands of data points to match you with bikes that perfectly suit your needs. We're committed to making motorcycle
                recommendations accessible to everyone, helping riders make informed decisions without the overwhelming research.
              </p>
            </div>
          </div>

          <div className='about-section creator-section'>
            <div className='section-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z' />
              </svg>
            </div>
            <div className='section-content'>
              <h2>The Founders</h2>
              <div className='creator-info'>
                <div className='creator-profile'>
                  <img src={subhrajitImg} alt='Subhrajit Pramanick' className='creator-image' />
                  <h3>Subhrajit Pramanick</h3>
                </div>
                <div className='social-links'>
                  <a href='https://www.linkedin.com/in/subhrajit2564/' target='_blank' rel='noopener noreferrer' className='social-link'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                      <path d='M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z' />
                    </svg>
                    Subhrajit Pramanick
                  </a>
                  <a href='https://www.instagram.com/lens_n_love/?hl=en' target='_blank' rel='noopener noreferrer' className='social-link'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                      <path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z' />
                    </svg>
                    @lens_n_love
                  </a>
                  <a href='mailto:subhrajit.pramanick@themotoguru.com' className='social-link'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                      <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' />
                    </svg>
                    Email Subhrajit
                  </a>
                </div>
              </div>
              <div className='creator-info'>
                <div className='creator-profile'>
                  <img src={bijitImg} alt='Bijit Sarkar' className='creator-image' />
                  <h3>Bijit Sarkar</h3>
                </div>
                <div className='social-links'>
                  <a href='mailto:sarkar.bijit2050@gmail.com' className='social-link'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                      <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' />
                    </svg>
                    Email Bijit
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className='about-section'>
            <div className='section-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                <path d='M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z' />
              </svg>
            </div>
            <div className='section-content'>
              <h2>Our Technology</h2>
              <p>
                We utilize cutting-edge AI algorithms to analyze thousands of motorcycle specifications, expert reviews, and user experiences, ensuring you get the most accurate motorcycle advice possible. Our system continuously learns and improves with each interaction, staying updated with the
                latest models and trends in the motorcycle industry. MotoGuru AI is more than just a recommendation tool—it's your personal motorcycle buying advisor.
              </p>
            </div>
          </div>
        </div>

        <div className='about-cta'>
          <a href='/' className='btn btn-primary'>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
              <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
            </svg>
            Find Your Perfect Motorcycle
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
